const sentryIgnoreErrors: (RegExp | string)[] = [
  /ttq.methods.length is not iterable/i,
  /\bTest Error\b/i, // Ignoring this will prevent 'Test Errors' including events from being pushed to Sentry.
  /undefined is not an object (evaluating 'window.webkit.messageHandlers')"/i,
  /Unexpected token '<'/i,

  // New additions
  /TypeError: o.methods.length is not iterable/,
  /undefined is not an object (evaluating 't.tab.customFillData')/,
  /Maximum update depth exceeded/,
  /Loading CSS chunk 669 failed./,
  /Both startTime and title fields are mandatory/,
  /Non-Error promise rejection captured with value/,
  /window\.webkit\.messageHandlers/,
  /Event `CustomEvent` \(type=unhandledrejection\)/,
  /TypeError/,
  /unable to fetch location details/i,
  /request.onerror/i,
  /loading CSS chunk/i,
  /settle/i,
  /axiosClass.callApi/i,
]

export default sentryIgnoreErrors
